import { NumberApplicationsByApplicant } from "./number-applicants";
export default NumberApplicationsByApplicant;
